import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import en from '../../../../lang/en-us';
import { SchemeSearchInput } from '../../../../lib/SearchInput';
import { RootStateType } from '../../../../redux-store/reducers';
import { Categories, FundSizes, MasterDataType } from '../../../../redux-store/types/newPurchase';
import { Filter, FilterKeys } from './types';
import { favLogos, logo } from '../../../../logo/logos';
import AsyncLoader from '../../../../lib/AsyncLoader';
import { NewPurchaseSkelton, AmcDetailSkelton } from '../../../../skeltons/NewPurchase';
import { ExplorePaths } from './types';
import { CommercialRootPath } from '../routeConfig';
import { saveSecretQuestions } from '../../../../redux-store/actions/login';

const { dbCommercial, common } = en;

const categoryInfoWithIconsAndDesc: any = {
    [Categories.Equity]: {
        description: dbCommercial.exploreMfs.equityInfo,
        icon: '/images/equity.svg',
    },

    [Categories.Debt]: {
        description: dbCommercial.exploreMfs.debtInfo,
        icon: '/images/debt.svg',
    },

    [Categories.Hybrid]: {
        description: dbCommercial.exploreMfs.hybridInfo,
        icon: '/images/hybrid.svg',
    },

    [Categories.Solution_Oriented]: {
        description: dbCommercial.exploreMfs.solutionOriented,
        icon: '/images/solution-oriented.svg',
    },
    [Categories.Other]: {
        description: dbCommercial.exploreMfs.other,
        icon: '/images/other.svg',
    },
};

const FundIcons: any = {
    [FundSizes['Below 100']]: '/images/below100Cr.svg',
    [FundSizes['100 - 200']]: '/images/upto500Cr.svg',
    [FundSizes['200 - 300']]: '/images/upto500Cr.svg',
    [FundSizes['300 - 500']]: '/images/upto1000Cr.svg',
    [FundSizes['500 - 1000']]: '/images/above1000Cr.svg',
    [FundSizes['More than 1000']]: '/images/above1000Cr.svg',
};

const RiskIconColor: any = {
    High: 'red',
    'Very High': 'red',
    Moderate: 'orange',
    'Moderately High': 'orange',
    Low: '#85c426',
};

export default function ExploreMFs(props: any) {
    const { amcDetails, categories, fundSizes, riskCategories } = useSelector(
        ({ newPurchase }: RootStateType) => ({ ...newPurchase.masterData }),
    );
    const { amcList } = useSelector(({ portfolio }: RootStateType) => ({ ...portfolio }));
    const history = useHistory();
    const onExploreSchemes = (filter: Filter, type: FilterKeys) => (): void => {
        history.push('explore', { [type]: [filter] });
    };

    return (
        <div className="curved-bg commercial-trans">
            <div className="explore-mf-heading">
                <h2 className="heading">
                    <a onClick={() => props.history.goBack()}>
                        <img src="/images/left-arrow-black.svg" alt="" />
                    </a>
                    {dbCommercial.exploreMfs.heading}
                </h2>
                <div className="explore-mf-search">
                    <SchemeSearchInput
                        id="search-mfs"
                        placeholder={dbCommercial.exploreMfs.searchmf}
                        darkmode={true}
                    />
                </div>
            </div>
            <div className="curved-bg-content explore-mf" tabIndex={0}>
                <div className="explore-mf-top">
                    <h3>{dbCommercial.exploreMfs.mfCategory}</h3>
                    <div className="all-mfs-outer">
                        <div className="all-mfs mf-category">
                            <AsyncLoader
                                skelton={<NewPurchaseSkelton />}
                                data={categories.length ? true : null}
                            >
                                <>
                                    {categories.map(({ categoryId, categoryName }) => (
                                        <a
                                            onClick={onExploreSchemes(
                                                { name: categoryName, value: categoryId },
                                                FilterKeys.Categories,
                                            )}
                                            key={categoryId}
                                            className="all-mfs-info"
                                            tabIndex={0}
                                        >
                                            <img
                                                src={
                                                    categoryInfoWithIconsAndDesc[`${categoryId}`]
                                                        ?.icon
                                                }
                                                alt=""
                                                aria-hidden="true"
                                            />
                                            <div className="mf-category-content">
                                                <div className="category-name">{categoryName}</div>
                                                <p>
                                                    {
                                                        categoryInfoWithIconsAndDesc[
                                                            `${categoryId}`
                                                        ]?.description
                                                    }
                                                </p>
                                            </div>
                                        </a>
                                    ))}
                                </>
                            </AsyncLoader>
                        </div>
                    </div>
                    <h3>
                        {dbCommercial.exploreMfs.allMfHouses}
                        <a
                            role="link"
                            tabIndex={0}
                            aria-label={`${dbCommercial.exploreMfs.viewAll} mutual fund houses`}
                            onClick={() => {
                                // Replace the / in /explore
                                const explore_path_relative = ExplorePaths.Explore.replace('/', '');
                                props.history.push(`${explore_path_relative}`);
                            }}
                            onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    const explore_path_relative = ExplorePaths.Explore.replace(
                                        '/',
                                        '',
                                    );
                                    props.history.push(`${explore_path_relative}`);
                                }
                            }}
                        >
                            {dbCommercial.exploreMfs.viewAll}
                            <img src="/images/right-arrow-purple.svg" alt="" aria-hidden="true" />
                        </a>
                    </h3>
                    <AsyncLoader
                        skelton={<AmcDetailSkelton />}
                        data={amcDetails.length ? true : null}
                    >
                        <div className="all-mfs-outer" style={{ borderBottom: 0 }}>
                            <div className="all-mfs" tabIndex={0}>
                                {amcDetails.map((item) => {
                                    let logoUrl = 'default';
                                    8;
                                    const currentAmc: any =
                                        amcList.find(
                                            (amc: any) =>
                                                amc.amc_name.toLowerCase() ===
                                                item.amcFullName.toLowerCase(),
                                        ) || undefined;
                                    if (!!currentAmc) {
                                        logoUrl = favLogos[currentAmc.amc_code];
                                    }
                                    return (
                                        <a
                                            key={item.amc}
                                            onClick={onExploreSchemes(
                                                { name: item.amcFullName, value: item.amc },
                                                FilterKeys.Amc,
                                            )}
                                            className="all-mfs-info"
                                            tabIndex={0}
                                        >
                                            <img
                                                style={{ width: '35px', height: '35px' }}
                                                src={
                                                    currentAmc && currentAmc.amc_code == 189
                                                        ? `/images/fav-logos/${favLogos['189-exception']}.svg`
                                                        : `/images/fav-logos/${logoUrl}.svg`
                                                }
                                                alt=""
                                                aria-hidden="true"
                                            />
                                            <p>{item.amcFullName}</p>
                                        </a>
                                    );
                                })}
                            </div>
                        </div>
                    </AsyncLoader>
                    {/* <h3>{dbCommercial.exploreMfs.mfFundSize}</h3> */}
                    {/* <div className="all-mfs-outer mf-fundsize-outer">
                        <div className="all-mfs mf-fundsize">
                            <AsyncLoader
                                skelton={<NewPurchaseSkelton height={40} />}
                                data={fundSizes.length ? true : null}
                            >
                                <>
                                    {fundSizes.map(({ name, id }) => (
                                        <a
                                            key={id}
                                            onClick={onExploreSchemes(
                                                { name, value: id },
                                                FilterKeys.FundSizes,
                                            )}
                                            className="all-mfs-info"
                                        >
                                            <img src={FundIcons[`${id}`]} alt={name} />
                                            <div className="fund-name">{name}</div>
                                        </a>
                                    ))}
                                </>
                            </AsyncLoader>
                        </div>
                    </div> */}
                </div>
                {/* <div className="explore-mf-bottom">
                    <h3>{dbCommercial.exploreMfs.mfByRisk}</h3>
                    <img
                        className="character"
                        src="/images/mf-risk-character.png"
                        alt="character"
                    />
                    <div className="mf-by-risk">
                        <AsyncLoader
                            skelton={<NewPurchaseSkelton height={50} className="mf-by-risk-info" />}
                            data={riskCategories.length ? true : null}
                        >
                            <>
                                {riskCategories.map(({ risk, id, name }) => (
                                    <a
                                        onClick={onExploreSchemes(
                                            { name, value: id },
                                            FilterKeys.Risk,
                                        )}
                                        key={id}
                                        className="mf-by-risk-info"
                                    >
                                        <h4>
                                            <span
                                                className="low"
                                                style={{ background: RiskIconColor[name] }}
                                            ></span>
                                            {name}
                                        </h4>
                                    </a>
                                ))}
                            </>
                        </AsyncLoader>
                    </div>
                </div> */}
            </div>
        </div>
    );
}
